import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import legacyStore from "./app/store";
import "./utils/fonts/LibreFranklin.ttf";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./react-datepicker.css";
import AppMobile from "./AppMobile";
import CorporatePortalApp from "./generated/corporateEntry";
import { startVersionWatcher } from "./utils/versionWatcher";

if (process.env.NODE_ENV === "production") {
  disableReactDevTools();
}

startVersionWatcher();

const root = ReactDOM.createRoot(document.getElementById("root"));

const { pathname } = window.location;

const pattern = /^\/payroll\/[^/]+\/[^/]+\/[^/]+(\/.*)?$/;
const patternQuickpay = /^\/quickpay(\/[^/]+){6}(\/.*)?$/;

const isMobilePayrollPath = pattern.test(pathname);
const isQuickpayPath = patternQuickpay.test(pathname);

if (!sessionStorage.getItem("SecureHashCleared")) {
  if (sessionStorage.getItem("SecureHashSaved")) {
    sessionStorage.removeItem("SecureHashSaved");
  }

  sessionStorage.setItem("SecureHashCleared", "true");
}


root.render(
  <>
    <ToastContainer
      position="top-center"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />

    {isMobilePayrollPath || isQuickpayPath ? (
      <Provider store={legacyStore}>
        <AppMobile />
      </Provider>
    ) : (
      <CorporatePortalApp />
    )}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
